import {noop} from 'lodash';
import React, {ComponentType, createContext, FC, useContext} from 'react';
import {Subtract} from 'utility-types';

/*
 * Props.
 */

export type PushEventSubscriber = (eventName: string, eventData: unknown) => void;

export interface ChatPushProps {
  emitChatPrecog: (conversationId: number, data: any) => void;
}

/*
 * Context.
 */

export const ChatPushContext = createContext<ChatPushProps>({
  emitChatPrecog: noop,
});

/*
 * Hook.
 */

export function useChatPush() {
  return useContext(ChatPushContext);
}

/*
 * HOC.
 */

export function withChatPush<T extends ChatPushProps>(
  Component: ComponentType<T>,
): FC<Subtract<T, ChatPushProps>> {
  return function (props) {
    return (
      <ChatPushContext.Consumer>
        {(context) => <Component {...(props as any)} {...context} />}
      </ChatPushContext.Consumer>
    );
  };
}
